import Login from "../views/Login.js";

var routeLogin = [
  { path: "/admin", component: Login },
];
export default routeLogin;